import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Trans } from 'react-i18next';

import { registerUpdateChange, emit } from 'services/electron-service';
import { isMac } from 'services/env-service';

import Alert from 'components/alert';

const DesktopAppUpdateAlert = () => {
    const [status, setStatus] = useState(null);
    const [updateProps, setUpdateProps] = useState(null);

    const handleRestartClick = () => {
        emit('restartAndInstall');
    }

    useEffect(() => {
        registerUpdateChange((status, props) => {
            setStatus(status);

            if (props) {
                setUpdateProps(props);
            }
        });
    }, []);

    return (
        <React.Fragment>
            {
                status ? (
                    <CSSTransition key="socket-error" timeout={300} classNames="alert">
                        <Alert
                            type={status !== 'error' ? 'success' : 'default'}
                            icon={status !== 'error' ? status === 'progress' ? <i class="icon material-icons icon-animate-rotate">autorenew</i> : <i className="icon material-icons">check_circle</i> : <i className="icon material-icons">error</i>}
                            visible={true}
                            noClose={true}
                        >
                            {
                                status === 'error' ? (
                                    <Trans
                                        i18nKey="common:desktopAppUpdateAlerts.error"
                                        components={{
                                            Button: <a href={'https://niftypm.com/apps/Nifty.' + (isMac() ? 'dmg' : 'exe')} target="_blank" rel="noopener noreferrer" />
                                        }}
                                    />
                                ) : status === 'available' ? (
                                    <Trans
                                        i18nKey="common:desktopAppUpdateAlerts.available"
                                    />
                                ) : status === 'progress' ? (
                                    <Trans
                                        i18nKey="common:desktopAppUpdateAlerts.progress"
                                        values={{
                                            count: Math.round(updateProps?.percent)
                                        }}
                                    />
                                ) : status === 'completed' ? (
                                    <Trans
                                        i18nKey="common:desktopAppUpdateAlerts.completed"
                                        components={{
                                            Button: <u className="clickable" onClick={handleRestartClick} />
                                        }}
                                    />
                                ) : null
                            }


                            <div></div>
                        </Alert>
                    </CSSTransition>
                ) : null
            }
        </React.Fragment>
    )
}

export default DesktopAppUpdateAlert;
